import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import AuthApi from '../../Services/Authapi';
import AuthCheckComponent from '../../Layouts/Token';
import TableComponent from '../../Layouts/TableComponent';
import swal from 'sweetalert';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import moment from 'moment';
import ls from 'local-storage';
import { CommonTablePagination } from '../../Common/commonPagination';
import {
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Tooltip,
  InputAdornment,
  Avatar,
  IconButton,
  Menu
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RefreshIcon from '@material-ui/icons/Refresh';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckIcon from '@material-ui/icons/Check';
import HistoryIcon from '@material-ui/icons/History';

import '../Leaves/Leave.css';
import './TaskManagement.css';
import '../LeavesTicket/Ticket.css';
import DdMmYyyyDateField from '../../../utils/DdMmYyyyDateField';
import WysiwygDescriptionEditor from './WysiwygDescriptionEditor';

// Status options for all tasks (includes user-requested 'In Discuss')
const TASK_STATUS_OPTIONS = [
  { id: 'Backlog', label: 'Backlog', value: 'backlog', color: '#475569', bg: '#f1f5f9', border: '#cbd5e1' },
  { id: 'Pending', label: 'To Do', value: 'todo', color: '#0284c7', bg: '#e0f2fe', border: '#bae6fd' },
  { id: 'In Progress', label: 'In Progress', value: 'inprogress', color: '#d97706', bg: '#fef3c7', border: '#fde68a' },
  { id: 'In Discuss', label: 'In Discuss', value: 'indiscuss', color: '#0284c7', bg: '#e0f2fe', border: '#bae6fd' },
  { id: 'Testing', label: 'Testing', value: 'testing', color: '#7c3aed', bg: '#f3e8ff', border: '#e9d5ff' },
  { id: 'Done', label: 'Done', value: 'done', color: '#047857', bg: '#d1fae5', border: '#a7f3d0' }
];

// Test options matching Status styling and colors
const TEST_STATUS_OPTIONS = [
  { id: 'Done', label: 'Done', color: '#047857', bg: '#d1fae5', border: '#a7f3d0' },
  { id: 'Inprogress', label: 'Inprogress', color: '#d97706', bg: '#fef3c7', border: '#fde68a' },
  { id: 'Pending', label: 'Pending', color: '#ca8a04', bg: '#fef9c3', border: '#fef08a' },
  { id: 'Need to discuss', label: 'Need to discuss', color: '#0284c7', bg: '#e0f2fe', border: '#bae6fd' },
  { id: 'Assign Task to', label: 'Assign Task to', color: '#475569', bg: '#f1f5f9', border: '#cbd5e1' }
];

// Priority options
const PRIORITY_OPTIONS = [
  { id: 'Urgent', label: 'Urgent', color: '#ef4444' },
  { id: 'High', label: 'High', color: '#f59e0b' },
  { id: 'Medium', label: 'Medium', color: '#6366f1' },
  { id: 'Low', label: 'Low', color: '#10b981' }
];

const LOCAL_STORAGE_KEY = 'cherrypik_task_history_meta_v1';
export const ARCHIVED_TASKS_KEY = 'cherrypik_archived_task_ids_v1';

class TaskHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      tasks: [],
      projects: [],
      allUsers: [],
      selectedProject: 'ALL',
      selectedStatus: 'ALL',
      searchQuery: '',

      // Task metadata map: { [taskId]: { branch_name, branch_created_from, local_test, staging_test } }
      taskMeta: this.loadTaskMeta(),
      archivedTaskIds: this.loadArchivedTaskIds(),
      selectedTaskIds: [],
      bulkAction: '',
      isArchiving: false,

      // Status Popover state
      statusAnchorEl: null,
      statusActiveTaskId: null,

      // Local Test Popover state
      localTestAnchorEl: null,
      localTestActiveTaskId: null,

      // Staging Test Popover state
      stagingTestAnchorEl: null,
      stagingTestActiveTaskId: null,

      // Priority Popover state
      priorityAnchorEl: null,
      priorityActiveTaskId: null,

      // Drawer state
      drawerOpen: false,
      activeDrawerTask: null,
      drawerActivityOpen: false,
      drawerActivityPage: 0,
      drawerActivityRowsPerPage: 5,
      drawerActivity: [],
      drawerLoadingActivity: false
    };
  }

  isUserSuperAdmin = () => {
    try {
      const roles = ls.get('roles') || ls('roles') || (this.props.authUser && this.props.authUser.roles);
      const role = ls.get('role') || ls('role') || (this.props.authUser && this.props.authUser.role);
      const adminRoles = ['super admin', 'admin', 'administrator'];

      if (typeof role === 'string' && adminRoles.includes(role.trim().toLowerCase())) {
        return true;
      }
      if (typeof roles === 'string' && adminRoles.includes(roles.trim().toLowerCase())) {
        return true;
      }
      if (Array.isArray(roles)) {
        return roles.some((r) => {
          const name = (typeof r === 'string' ? r : (r && r.name) || '').trim().toLowerCase();
          return adminRoles.includes(name);
        });
      }
      return false;
    } catch (_) {
      return false;
    }
  };

  getCurrentUserId = () => {
    try {
      let user = ls.get('user') || ls('user');
      if (typeof user === 'string') {
        try { user = JSON.parse(user); } catch (_) {}
      }
      if ((!user || typeof user !== 'object') && typeof window !== 'undefined') {
        const raw = window.localStorage.getItem('user');
        if (raw) {
          try { user = JSON.parse(raw); } catch (_) {}
        }
      }
      return (user && (user.id || user._id || user.user_id)) || null;
    } catch (_) {
      return null;
    }
  };

  isProjectVisibleToUser = (project, userId) => {
    if (!project || !userId) return false;
    const uid = Number(userId);

    const members = (this.extractIds(project.member_ids) || []).map(Number);
    const leads = [
      ...(this.extractIds(project.lead_ids) || []),
      ...(project.lead_id ? this.extractIds(project.lead_id) : [])
    ].map(Number);
    const assignedIds = [...members, ...leads];
    return assignedIds.includes(uid);
  };

  filterProjectsByPermission = (projectsList) => {
    const isSuperAdmin = this.isUserSuperAdmin();
    const currentUserId = this.getCurrentUserId();
    if (isSuperAdmin) {
      return projectsList;
    }
    if (!currentUserId) {
      return [];
    }
    return (projectsList || []).filter((p) => this.isProjectVisibleToUser(p, currentUserId));
  };

  loadTaskMeta = () => {
    try {
      const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch (_) {
      return {};
    }
  };

  saveTaskMeta = (newMeta) => {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newMeta));
    } catch (_) {}
  };

  loadArchivedTaskIds = () => {
    try {
      const stored = localStorage.getItem(ARCHIVED_TASKS_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (_) {
      return [];
    }
  };

  saveArchivedTaskIds = (ids) => {
    try {
      localStorage.setItem(ARCHIVED_TASKS_KEY, JSON.stringify(ids));
    } catch (_) {}
  };

  handleBulkActionSubmit = () => {
    const { selectedTaskIds = [], bulkAction = '' } = this.state;
    if (!bulkAction || selectedTaskIds.length === 0) {
      swal('Warning', 'Please select tasks and a bulk action to apply.', 'warning');
      return;
    }

    if (bulkAction === 'bulk_archive') {
      swal({
        title: 'Confirm Bulk Archive',
        text: `Are you sure you want to archive ${selectedTaskIds.length} selected task(s)? These tasks will be moved to the Archive page.`,
        icon: 'warning',
        buttons: ['Cancel', 'Yes, Archive'],
        dangerMode: false
      }).then((willArchive) => {
        if (willArchive) {
          this.archiveSelectedTasks();
        }
      });
    }
  };

  archiveSelectedTasks = () => {
    const { selectedTaskIds = [], archivedTaskIds = [], taskMeta = {} } = this.state;
    const count = selectedTaskIds.length;

    swal({
      title: 'Archiving Tasks',
      text: 'Please wait...',
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode()
    });

    // Merge new IDs ensuring uniqueness
    const updatedArchivedIds = Array.from(new Set([...archivedTaskIds, ...selectedTaskIds.map(String)]));
    this.saveArchivedTaskIds(updatedArchivedIds);

    // Also update taskMeta with archived flag
    const updatedMeta = { ...taskMeta };
    selectedTaskIds.forEach((id) => {
      updatedMeta[id] = {
        ...(updatedMeta[id] || {}),
        is_archived: true,
        archived_at: new Date().toISOString()
      };
    });
    this.saveTaskMeta(updatedMeta);

    this.setState({
      archivedTaskIds: updatedArchivedIds,
      taskMeta: updatedMeta,
      selectedTaskIds: [],
      bulkAction: ''
    });

    swal('Success', `${count} task(s) archived successfully!`, 'success');
  };

  renderBottomBarControls = () => {
    const { selectedTaskIds = [], bulkAction = '', isArchiving = false } = this.state;

    return (
      <div className="leave-ticket-bulk-actions">
        <Select
          className="custom-filter-select"
          value={bulkAction}
          onChange={(e) => this.setState({ bulkAction: e.target.value })}
          style={{ marginRight: '10px', minWidth: '150px', backgroundColor: 'transparent' }}
          displayEmpty
          disabled={isArchiving}
          MenuProps={{ classes: { paper: 'leave-status-menu' } }}
        >
          <MenuItem value="">
            <em>Select Bulk Action</em>
          </MenuItem>
          <MenuItem value="bulk_archive">
            Bulk Archive
          </MenuItem>
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={this.handleBulkActionSubmit}
          disabled={selectedTaskIds.length === 0 || !bulkAction || isArchiving}
        >
          GO
        </Button>
      </div>
    );
  };

  async componentDidMount() {
    if (this._hasLoadedData) return;
    this._hasLoadedData = true;
    await this.initData();
  }

  componentWillUnmount() {
    if (this._branchDebounceTimers) {
      Object.keys(this._branchDebounceTimers).forEach((id) => {
        clearTimeout(this._branchDebounceTimers[id]);
      });
    }
  }

  initData = async () => {
    this.setState({ loading: true });
    try {
      const [projectsRes, usersRes, tasksRes] = await Promise.all([
        AuthApi.getProject(),
        AuthApi.getData(),
        AuthApi.getTasks()
      ]);

      const projectsData = (projectsRes && projectsRes.data) || projectsRes || [];
      const allProjects = Array.isArray(projectsData) ? projectsData.filter((p) => !p.deleted) : [];
      const visibleProjects = this.filterProjectsByPermission(allProjects);

      const usersData = (usersRes && usersRes.data) || usersRes || [];
      const allUsers = Array.isArray(usersData) ? usersData : [];
      const activeUsers = allUsers.filter((u) => Number(u.user_logged) === 1);

      let res = tasksRes;
      if (!res || (res.status === false && !Array.isArray(res.data))) {
        if (typeof AuthApi.taskslistbyuserid === 'function') {
          res = await AuthApi.taskslistbyuserid();
        }
      }

      const rawTasks = (res && res.data) || (Array.isArray(res) ? res : []);
      const tasks = Array.isArray(rawTasks) ? rawTasks.map(this.normalizeTask) : [];

      // Sync branch and test status metadata between DB and local state
      const currentMeta = { ...this.state.taskMeta };
      tasks.forEach((t) => {
        const local = currentMeta[t.id] || {};
        if (t.branch_name !== undefined && t.branch_name !== null && t.branch_name !== '') {
          local.branch_name = t.branch_name;
        } else if (local.branch_name) {
          this.syncBranchToBackend(t.id);
        }

        if (t.branch_created_from !== undefined && t.branch_created_from !== null && t.branch_created_from !== '') {
          local.branch_created_from = t.branch_created_from;
        } else if (local.branch_created_from) {
          this.syncBranchToBackend(t.id);
        }

        if (t.local_test !== undefined && t.local_test !== null && t.local_test !== '') {
          local.local_test = t.local_test;
        } else if (!local.local_test) {
          local.local_test = 'Pending';
        }

        if (t.staging_test !== undefined && t.staging_test !== null && t.staging_test !== '') {
          local.staging_test = t.staging_test;
        } else if (!local.staging_test) {
          local.staging_test = 'Pending';
        }

        currentMeta[t.id] = local;
      });
      this.saveTaskMeta(currentMeta);

      this.setState({
        projects: visibleProjects,
        allUsers,
        activeUsers,
        tasks,
        taskMeta: currentMeta,
        loading: false
      });
    } catch (e) {
      console.error('Error initializing Task History data', e);
      this.setState({ loading: false });
    }
  };

  fetchTasks = async () => {
    this.setState({ loading: true });
    try {
      let res = await AuthApi.getTasks();
      if (!res || (res.status === false && !Array.isArray(res.data))) {
        if (typeof AuthApi.taskslistbyuserid === 'function') {
          res = await AuthApi.taskslistbyuserid();
        }
      }

      const rawTasks = (res && res.data) || (Array.isArray(res) ? res : []);
      const tasks = Array.isArray(rawTasks) ? rawTasks.map(this.normalizeTask) : [];

      const currentMeta = { ...this.state.taskMeta };
      tasks.forEach((t) => {
        const local = currentMeta[t.id] || {};
        if (t.branch_name !== undefined && t.branch_name !== null && t.branch_name !== '') {
          local.branch_name = t.branch_name;
        } else if (local.branch_name) {
          this.syncBranchToBackend(t.id);
        }

        if (t.branch_created_from !== undefined && t.branch_created_from !== null && t.branch_created_from !== '') {
          local.branch_created_from = t.branch_created_from;
        } else if (local.branch_created_from) {
          this.syncBranchToBackend(t.id);
        }

        if (t.local_test !== undefined && t.local_test !== null && t.local_test !== '') {
          local.local_test = t.local_test;
        } else if (!local.local_test) {
          local.local_test = 'Pending';
        }

        if (t.staging_test !== undefined && t.staging_test !== null && t.staging_test !== '') {
          local.staging_test = t.staging_test;
        } else if (!local.staging_test) {
          local.staging_test = 'Pending';
        }

        currentMeta[t.id] = local;
      });
      this.saveTaskMeta(currentMeta);

      this.setState({
        tasks,
        taskMeta: currentMeta,
        loading: false
      });
    } catch (e) {
      console.error('Error fetching tasks', e);
      this.setState({ tasks: [], loading: false });
    }
  };

  normalizeTask = (task) => {
    let subtasks = [];
    const rawSubtasks = task.sub_tasks || task.subTasks;
    if (rawSubtasks) {
      try {
        let parsed = typeof rawSubtasks === 'string' ? JSON.parse(rawSubtasks) : rawSubtasks;
        while (typeof parsed === 'string') {
          parsed = JSON.parse(parsed);
        }
        subtasks = Array.isArray(parsed) ? parsed : [];
      } catch (_) {
        subtasks = [];
      }
    }

    let activityLogs = [];
    if (task.activity_logs) {
      try {
        const parsedLogs = typeof task.activity_logs === 'string' ? JSON.parse(task.activity_logs) : task.activity_logs;
        activityLogs = Array.isArray(parsedLogs) ? parsedLogs : [];
      } catch (_) {
        activityLogs = [];
      }
    }

    const rawPriority = (task.task_priority || task.priority || 'Medium').trim();
    const priorityMap = {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      urgent: 'Urgent'
    };
    const priority = priorityMap[rawPriority.toLowerCase()] || 'Medium';

    return {
      ...task,
      branch_name: task.branch_name || '',
      branch_created_from: task.branch_created_from || '',
      local_test: task.local_test || 'Pending',
      staging_test: task.staging_test || 'Pending',
      priority,
      sub_tasks_parsed: subtasks,
      activity_logs_parsed: activityLogs
    };
  };

  extractIds = (raw) => {
    if (!raw) return [];
    if (Array.isArray(raw)) {
      return raw.map((item) => (item && typeof item === 'object' ? item.id : item)).filter(Boolean);
    }
    if (typeof raw === 'string') {
      const trimmed = raw.trim();
      if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed
              .map((item) => (item && typeof item === 'object' ? item.id : item))
              .filter(Boolean);
          }
        } catch (_) {}
      }
      return trimmed
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
    }
    return [raw];
  };

  getAssignedUsersForTask = (task) => {
    if (!task) return [];
    const { allUsers, activeUsers } = this.state;
    const matchedUsers = [];
    const matchedIds = new Set();
    const matchedNames = new Set();

    // Prefer active users pool (user_logged === 1)
    const userPool = (activeUsers && activeUsers.length > 0)
      ? activeUsers
      : (allUsers && allUsers.length > 0 ? allUsers.filter((u) => Number(u.user_logged) === 1) : []);
    const fallbackPool = (allUsers && allUsers.length > 0) ? allUsers : userPool;

    // 1. If task has explicit member_ids or developer_user_ids
    const rawIds = task.member_ids || task.developer_user_ids || [];
    const extractedIds = this.extractIds(rawIds);
    if (extractedIds.length > 0) {
      extractedIds.forEach((id) => {
        const u = userPool.find((user) => Number(user.id) === Number(id)) ||
          fallbackPool.find((user) => Number(user.id) === Number(id));
        if (u && !matchedIds.has(Number(u.id))) {
          matchedUsers.push(u);
          matchedIds.add(Number(u.id));
          const fn = `${u.firstName || ''} ${u.lastName || ''}`.trim().toLowerCase();
          if (fn) matchedNames.add(fn);
          if (u.name) matchedNames.add(u.name.trim().toLowerCase());
          if (u.firstName) matchedNames.add(u.firstName.trim().toLowerCase());
        }
      });
      if (matchedUsers.length > 0) {
        return matchedUsers;
      }
    }

    // 2. By primary developer_user_id
    if (task.developer_user_id) {
      const primaryId = Number(task.developer_user_id);
      if (!matchedIds.has(primaryId)) {
        const u = userPool.find((user) => Number(user.id) === primaryId) ||
          fallbackPool.find((user) => Number(user.id) === primaryId);
        if (u) {
          matchedUsers.push(u);
          matchedIds.add(primaryId);
          const fn = `${u.firstName || ''} ${u.lastName || ''}`.trim().toLowerCase();
          if (fn) matchedNames.add(fn);
          if (u.name) matchedNames.add(u.name.trim().toLowerCase());
          if (u.firstName) matchedNames.add(u.firstName.trim().toLowerCase());
        }
      }
    }

    // 3. By developer_name (which can be comma-separated names of assigned developers)
    const rawDevNames = task.developer_name || task.assigned_developer;
    if (rawDevNames && typeof rawDevNames === 'string') {
      const names = rawDevNames.split(',').map((n) => n.trim()).filter(Boolean);
      names.forEach((nameStr) => {
        const lower = nameStr.toLowerCase();

        if (matchedNames.has(lower)) {
          return;
        }
        const alreadyMatched = matchedUsers.some((u) => {
          const fn = `${u.firstName || ''} ${u.lastName || ''}`.trim().toLowerCase();
          const alt = (u.name || '').trim().toLowerCase();
          const firstOnly = (u.firstName || '').trim().toLowerCase();
          return fn === lower || alt === lower || firstOnly === lower;
        });
        if (alreadyMatched) {
          return;
        }

        // Match from active user pool or fallback pool
        const u = userPool.find((user) => {
          if (matchedIds.has(Number(user.id))) return false;
          const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim().toLowerCase();
          const altName = (user.name || '').trim().toLowerCase();
          const first = (user.firstName || '').trim().toLowerCase();
          return fullName === lower || altName === lower || first === lower;
        }) || fallbackPool.find((user) => {
          if (matchedIds.has(Number(user.id))) return false;
          const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim().toLowerCase();
          const altName = (user.name || '').trim().toLowerCase();
          const first = (user.firstName || '').trim().toLowerCase();
          return fullName === lower || altName === lower || first === lower;
        });

        if (u && !matchedIds.has(Number(u.id))) {
          matchedUsers.push(u);
          matchedIds.add(Number(u.id));
          const fn = `${u.firstName || ''} ${u.lastName || ''}`.trim().toLowerCase();
          if (fn) matchedNames.add(fn);
          if (u.name) matchedNames.add(u.name.trim().toLowerCase());
          if (u.firstName) matchedNames.add(u.firstName.trim().toLowerCase());
        } else if (!u) {
          matchedUsers.push({
            id: `dev_${nameStr}`,
            name: nameStr,
            firstName: nameStr
          });
          matchedNames.add(lower);
        }
      });
    }

    // 4. By other ID fields (assigned_developer_id, developer_id, assigned_to, user_id, assignee_id)
    const otherRaw =
      task.assigned_developer_id ||
      task.developer_id ||
      task.assigned_to ||
      task.user_id ||
      task.assignee_id;
    if (otherRaw) {
      const otherIds = this.extractIds(otherRaw);
      otherIds.forEach((id) => {
        const u = fallbackPool.find((user) => Number(user.id) === Number(id));
        if (u && !matchedIds.has(Number(u.id))) {
          matchedUsers.push(u);
          matchedIds.add(Number(u.id));
        }
      });
    }

    return matchedUsers;
  };

  getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  renderAssigneeAvatars = (task) => {
    const users = this.getAssignedUsersForTask(task);
    if (!users || users.length === 0) {
      return (
        <span className="tm-history-unassigned" style={{ fontSize: '13px', fontStyle: 'italic' }}>
          Unassigned
        </span>
      );
    }

    const maxVisible = 4;
    const visibleUsers = users.slice(0, maxVisible);
    const remainingCount = users.length - maxVisible;
    const allNames = users
      .map((u) => (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : u.name || 'User'))
      .join(', ');

    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'nowrap' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {visibleUsers.map((user, idx) => {
            const displayName = user.firstName
              ? `${user.firstName} ${user.lastName || ''}`.trim()
              : user.name || 'User';
            return (
              <Tooltip key={user.id || idx} title={displayName} arrow placement="top">
                <Avatar
                  src={user.photo || ''}
                  style={{
                    width: 26,
                    height: 26,
                    fontSize: '0.68rem',
                    fontWeight: 400,
                    marginLeft: idx === 0 ? 0 : -8,
                    border: '2px solid #ffffff',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.12)',
                    backgroundColor: '#036dda',
                    color: '#ffffff',
                    cursor: 'pointer'
                  }}
                >
                  {this.getInitials(displayName)}
                </Avatar>
              </Tooltip>
            );
          })}

          {remainingCount > 0 && (
            <Tooltip title={`${users.length} users assigned (${allNames})`} arrow placement="top">
              <div
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: '50%',
                  backgroundColor: '#e2e8f0',
                  color: '#334155',
                  fontSize: '0.65rem',
                  fontWeight: 400,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: -8,
                  border: '2px solid #ffffff',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.12)',
                  cursor: 'pointer'
                }}
              >
                +{remainingCount}
              </div>
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  // Update Branch Name, Branch-Created From, Date, or Test Status directly in table
  handleInlineMetaChange = (taskId, field, value) => {
    const updated = {
      ...this.state.taskMeta,
      [taskId]: {
        ...(this.state.taskMeta[taskId] || {}),
        [field]: value
      }
    };
    const updatedTasks = this.state.tasks.map((t) =>
      t.id === taskId ? { ...t, [field]: value } : t
    );
    this.setState({ taskMeta: updated, tasks: updatedTasks });
    this.saveTaskMeta(updated);

    if (field === 'branch_name' || field === 'branch_created_from') {
      this.debounceSyncBranch(taskId);
    }

    if (field === 'local_test' || field === 'staging_test') {
      try {
        if (typeof AuthApi.updateTaskTestStatus === 'function') {
          AuthApi.updateTaskTestStatus(taskId, { [field]: value });
        }
      } catch (err) {
        console.error('Failed to sync test status to DB', err);
      }
    }

    if (field === 'done_date' && value) {
      try {
        if (typeof AuthApi.updateTaskDoneDate === 'function') {
          AuthApi.updateTaskDoneDate(taskId, value);
        }
      } catch (err) {
        console.error('Failed to sync done date to DB', err);
      }
    }
  };

  debounceSyncBranch = (taskId) => {
    if (!this._branchDebounceTimers) {
      this._branchDebounceTimers = {};
    }
    if (this._branchDebounceTimers[taskId]) {
      clearTimeout(this._branchDebounceTimers[taskId]);
    }
    this._branchDebounceTimers[taskId] = setTimeout(() => {
      this.syncBranchToBackend(taskId);
      delete this._branchDebounceTimers[taskId];
    }, 600);
  };

  syncBranchToBackend = async (taskId) => {
    if (this._branchDebounceTimers && this._branchDebounceTimers[taskId]) {
      clearTimeout(this._branchDebounceTimers[taskId]);
      delete this._branchDebounceTimers[taskId];
    }
    const meta = (this.state.taskMeta && this.state.taskMeta[taskId]) || {};
    const task = (this.state.tasks && this.state.tasks.find((t) => t.id === taskId)) || {};
    const branch_name = meta.branch_name !== undefined ? meta.branch_name : (task.branch_name || '');
    const branch_created_from = meta.branch_created_from !== undefined ? meta.branch_created_from : (task.branch_created_from || '');

    try {
      if (typeof AuthApi.updateTaskBranch === 'function') {
        await AuthApi.updateTaskBranch(taskId, {
          branch_name,
          branch_created_from
        });
      }
    } catch (err) {
      console.error('Failed to sync branch details to DB', err);
    }
  };

  // Status Change Handler
  handleStatusChange = async (taskId, newStatus) => {
    const task = this.state.tasks.find((t) => t.id === taskId);
    if (!task) return;

    const previousStatus = task.status;
    const isDone = String(newStatus).toLowerCase() === 'done';
    const doneDate = isDone ? moment().format('YYYY-MM-DD') : null;

    const updatedTasks = this.state.tasks.map((t) =>
      t.id === taskId ? { ...t, status: newStatus, ...(isDone ? { done_date: doneDate } : { done_date: null }) } : t
    );
    this.setState({ tasks: updatedTasks });

    // If marked done, update done_date in taskMeta
    if (isDone) {
      const updatedMeta = {
        ...this.state.taskMeta,
        [taskId]: {
          ...(this.state.taskMeta[taskId] || {}),
          done_date: doneDate
        }
      };
      this.setState({ taskMeta: updatedMeta });
      this.saveTaskMeta(updatedMeta);
    }

    try {
      if (typeof AuthApi.updateTaskStatus === 'function') {
        await AuthApi.updateTaskStatus(taskId, newStatus, doneDate);
      } else if (typeof AuthApi.updateTask === 'function') {
        await AuthApi.updateTask(taskId, { ...task, status: newStatus, done_date: doneDate });
      }
    } catch (e) {
      console.error('Failed to update task status in DB', e);
      const reverted = this.state.tasks.map((t) =>
        t.id === taskId ? { ...t, status: previousStatus } : t
      );
      this.setState({ tasks: reverted });
      swal('Error', 'Could not update status. Reverted.', 'error');
    }
  };

  // Priority Change Handler
  handlePriorityChange = async (taskId, newPriority) => {
    const task = this.state.tasks.find((t) => t.id === taskId);
    if (!task) return;

    const updatedTasks = this.state.tasks.map((t) =>
      t.id === taskId ? { ...t, priority: newPriority } : t
    );
    this.setState({ tasks: updatedTasks });

    try {
      if (typeof AuthApi.updateTask === 'function') {
        await AuthApi.updateTask(taskId, { ...task, priority: newPriority });
      }
    } catch (e) {
      console.error('Failed to update priority', e);
    }
  };

  sortActivityLogsLatestFirst = (logs) => {
    if (!Array.isArray(logs) || logs.length === 0) return [];

    const indexed = logs.map((log, index) => ({ log, originalIndex: index }));

    indexed.sort((a, b) => {
      const timeA = (a.log && (a.log.timestamp || a.log.created_at)) || '';
      const timeB = (b.log && (b.log.timestamp || b.log.created_at)) || '';

      const momA = timeA ? moment(timeA, ['DD-MM-YYYY hh:mm A', 'DD-MM-YYYY HH:mm', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ss', moment.ISO_8601]) : null;
      const momB = timeB ? moment(timeB, ['DD-MM-YYYY hh:mm A', 'DD-MM-YYYY HH:mm', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ss', moment.ISO_8601]) : null;

      const validA = momA && momA.isValid();
      const validB = momB && momB.isValid();

      if (validA && validB) {
        const diff = momB.valueOf() - momA.valueOf();
        if (diff !== 0) return diff; // newest timestamp first
      } else if (validA) {
        return -1;
      } else if (validB) {
        return 1;
      }

      // Fallback: later appended entries have higher originalIndex, show them first
      return b.originalIndex - a.originalIndex;
    });

    return indexed.map(item => item.log);
  };

  // Drawer handlers
  handleOpenDrawer = async (taskOrRow) => {
    if (!taskOrRow) return;
    const taskId = taskOrRow.id;
    const pristineTask = (this.state.tasks || []).find((t) => Number(t.id) === Number(taskId)) || taskOrRow;
    const taskTitle =
      typeof pristineTask.task === 'string'
        ? pristineTask.task
        : (typeof taskOrRow.task === 'string'
            ? taskOrRow.task
            : (pristineTask.task_name || taskOrRow.task_name || ''));

    const activeTask = {
      ...pristineTask,
      task: taskTitle
    };

    this.setState({
      drawerOpen: true,
      activeDrawerTask: activeTask,
      drawerLoadingActivity: false,
      drawerActivityPage: 0,
      drawerActivity: this.sortActivityLogsLatestFirst(activeTask.activity_logs_parsed || [])
    });

    await this.fetchDrawerActivity(taskId);
  };

  fetchDrawerActivity = async (taskId) => {
    if (!taskId) return;
    try {
      if (typeof AuthApi.getActivityLogs === 'function') {
        const res = await AuthApi.getActivityLogs(taskId);
        const logs = (res && (res.data || res.logs)) || (Array.isArray(res) ? res : []);
        if (Array.isArray(logs) && logs.length > 0) {
          this.setState({ drawerActivity: this.sortActivityLogsLatestFirst(logs), drawerLoadingActivity: false });
          return;
        }
      }
      if (typeof AuthApi.getTaskActivity === 'function') {
        const res = await AuthApi.getTaskActivity(taskId);
        const logs = (res && res.data) || (Array.isArray(res) ? res : []);
        if (Array.isArray(logs) && logs.length > 0) {
          this.setState({ drawerActivity: this.sortActivityLogsLatestFirst(logs), drawerLoadingActivity: false });
          return;
        }
      }
    } catch (_) {}

    this.setState({ drawerLoadingActivity: false });
  };

  handleCloseDrawer = () => {
    this.setState({ drawerOpen: false, activeDrawerTask: null });
  };

  formatDate = (dateStr) => {
    if (!dateStr) return '—';
    try {
      const m = moment(dateStr);
      return m.isValid() ? m.format('DD MMM YYYY') : dateStr;
    } catch (_) {
      return dateStr;
    }
  };

  formatDateTime = (dateStr) => {
    if (!dateStr || String(dateStr).trim() === '' || String(dateStr).startsWith('0000-00-00')) return '—';
    try {
      const str = String(dateStr).trim();
      if (str.includes('T') || str.endsWith('Z')) {
        const mIso = moment(str);
        if (mIso.isValid()) {
          return mIso.local().format('DD MMM YYYY, hh:mm A');
        }
      }
      const m = moment(str, [
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DD HH:mm',
        'DD-MM-YYYY HH:mm:ss',
        'DD-MM-YYYY hh:mm A',
        'DD-MM-YYYY HH:mm',
        'DD-MM-YYYY',
        'YYYY-MM-DD'
      ], true);
      if (m.isValid()) {
        return m.format('DD MMM YYYY, hh:mm A');
      }
      const mFallback = moment(str);
      return mFallback.isValid() ? mFallback.local().format('DD MMM YYYY, hh:mm A') : dateStr;
    } catch (_) {
      return dateStr;
    }
  };

  // Universal status style resolver: colored font without background box
  getStatusBadgeStyle = (rawStatus) => {
    const s = String(rawStatus || '').toLowerCase().trim();
    if (s === 'done') {
      return { id: 'Done', label: 'Done', color: '#059669', key: 'done' };
    }
    if (s === 'inprogress' || s === 'in progress') {
      return { id: 'In Progress', label: rawStatus || 'Inprogress', color: '#d97706', key: 'inprogress' };
    }
    if (s === 'to do' || s === 'todo') {
      return { id: 'To Do', label: 'To Do', color: '#0284c7', key: 'todo' };
    }
    if (s === 'pending') {
      return { id: 'Pending', label: 'Pending', color: '#ca8a04', key: 'pending' };
    }
    if (s === 'need to discuss' || s === 'in discuss' || s === 'indiscuss') {
      return { id: rawStatus || 'In Discuss', label: rawStatus || 'Need to discuss', color: '#0284c7', key: 'indiscuss' };
    }
    if (s === 'testing' || s === 'testing / review') {
      return { id: 'Testing', label: 'Testing', color: '#7c3aed', key: 'testing' };
    }
    if (s === 'assign task to') {
      return { id: 'Assign Task to', label: 'Assign Task to', color: '#64748b', key: 'backlog' };
    }
    if (s === 'backlog') {
      return { id: 'Backlog', label: 'Backlog', color: '#64748b', key: 'backlog' };
    }
    return { id: rawStatus || 'Select', label: rawStatus || 'Select', color: '#64748b', key: 'default' };
  };

  // Render Status text button with colored font
  renderStatusBadge = (value, onOpenMenu) => {
    const rawStatus = value || 'Done';
    const opt = this.getStatusBadgeStyle(rawStatus);

    return (
      <button
        type="button"
        onClick={onOpenMenu}
        className="tm-history-status-text-btn"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          padding: '2px 4px',
          background: 'none',
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          boxShadow: 'none',
          color: opt.color,
          fontSize: '0.76rem',
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          fontWeight: 400,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          lineHeight: 1.35,
          transition: 'opacity 0.15s ease'
        }}
        title="Click to change status"
      >
        <span>{opt.label}</span>
        <ExpandMoreIcon style={{ fontSize: 14, color: opt.color, opacity: 0.85 }} />
      </button>
    );
  };

  // Render Test text button with colored font
  renderTestStatusBadge = (value, onOpenMenu) => {
    const opt = this.getStatusBadgeStyle(value || 'Pending');

    return (
      <button
        type="button"
        onClick={onOpenMenu}
        className="tm-history-status-text-btn"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          padding: '2px 4px',
          background: 'none',
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          boxShadow: 'none',
          color: opt.color,
          fontSize: '0.76rem',
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          fontWeight: 400,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          lineHeight: 1.35,
          transition: 'opacity 0.15s ease'
        }}
        title="Click to change test status"
      >
        <span>{opt.label}</span>
        <ExpandMoreIcon style={{ fontSize: 14, color: opt.color, opacity: 0.85 }} />
      </button>
    );
  };

  getEffectiveTaskDate = (task) => {
    if (!task) return moment().format('YYYY-MM-DD');
    const meta = this.state.taskMeta[task.id] || {};

    // 1. Check if task has done_date from database
    if (task.done_date && !String(task.done_date).startsWith('0000-00-00')) {
      const m = moment(task.done_date, [
        'YYYY-MM-DD',
        'YYYY-MM-DD HH:mm:ss',
        'DD-MM-YYYY',
        'DD-MM-YYYY HH:mm:ss',
        'DD/MM/YYYY'
      ]);
      if (m.isValid()) return m.format('YYYY-MM-DD');
      return String(task.done_date).slice(0, 10);
    }

    // 2. Check if explicitly saved in taskMeta
    if (meta.done_date && !String(meta.done_date).startsWith('0000-00-00')) {
      return meta.done_date;
    }

    // 3. Extract from activity logs (timestamp of when status was marked Done)
    const logs = task.activity_logs_parsed || [];
    for (let i = logs.length - 1; i >= 0; i--) {
      const desc = logs[i].description || '';
      if (/status updated to 'Done'/i.test(desc) && logs[i].timestamp) {
        const m = moment(logs[i].timestamp, [
          'DD-MM-YYYY hh:mm A',
          'DD-MM-YYYY HH:mm',
          'DD-MM-YYYY',
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DD'
        ]);
        if (m.isValid()) {
          return m.format('YYYY-MM-DD');
        }
      }
    }

    // 4. Fallback to updated_at or created_at
    const candidate = task.updated_at || task.created_at || task.task_deliver_date || task.task_date_time;
    if (candidate && !String(candidate).startsWith('0000-00-00')) {
      const m = moment(candidate);
      if (m.isValid()) {
        return m.format('YYYY-MM-DD');
      }
      return String(candidate).slice(0, 10);
    }

    return moment().format('YYYY-MM-DD');
  };

  matchesSearchQuery = (task, query) => {
    if (!query || !query.trim()) return true;
    const q = query.toLowerCase().trim();
    const qClean = q.replace(/[\/\-\.\s]/g, '');

    const meta = this.state.taskMeta[task.id] || {};
    const effectiveDate = this.getEffectiveTaskDate(task);

    // 1. DATE SEARCH (Supports DD/MM/YYYY, DD-MM-YYYY, YYYY-MM-DD, month names, day, year)
    const taskDates = [
      effectiveDate,
      meta.done_date,
      task.done_date,
      task.task_deliver_date,
      task.task_date_time,
      task.created_at,
      task.date,
      task.updated_at
    ].filter(Boolean);

    const matchesDate = taskDates.some((d) => {
      if (!d || String(d).startsWith('0000-00-00')) return false;
      const strRaw = String(d).toLowerCase();
      if (strRaw.includes(q)) return true;
      if (strRaw.replace(/[\/\-\.\s]/g, '').includes(qClean)) return true;

      const m = moment(d, [
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DD HH:mm',
        'YYYY-MM-DD',
        'DD/MM/YYYY',
        'DD-MM-YYYY',
        'DD-MM-YYYY HH:mm:ss',
        'YYYY-MM-DDTHH:mm:ss.SSSZ'
      ]);

      if (m.isValid()) {
        const formats = [
          m.format('DD/MM/YYYY'),
          m.format('DD-MM-YYYY'),
          m.format('YYYY-MM-DD'),
          m.format('D/M/YYYY'),
          m.format('D-M-YYYY'),
          m.format('DD/MM'),
          m.format('DD-MM'),
          m.format('DD MMM YYYY'),
          m.format('DD MMMM YYYY'),
          m.format('MMMM DD, YYYY'),
          m.format('MMM DD, YYYY'),
          m.format('DD MMM'),
          m.format('DD MMMM'),
          m.format('MMMM'),
          m.format('MMM')
        ].map((f) => f.toLowerCase());

        if (formats.some((f) => f.includes(q) || f.replace(/[\/\-\.\s]/g, '').includes(qClean))) {
          return true;
        }
      }
      return false;
    });

    if (matchesDate) return true;

    // 2. TASK NAME SEARCH (Title and Key)
    const taskName = String(task.task || '').toLowerCase();
    const taskId = String(task.project_task_id || '').toLowerCase();
    const taskNumId = String(task.id || '');
    if (taskName.includes(q) || taskId.includes(q) || taskNumId === q) {
      return true;
    }

    // 3. BRANCH NAME SEARCH (Branch Name and Branch-Created From)
    const branchName = String((meta.branch_name !== undefined ? meta.branch_name : task.branch_name) || '').toLowerCase();
    const branchCreatedFrom = String((meta.branch_created_from !== undefined ? meta.branch_created_from : task.branch_created_from) || '').toLowerCase();
    if (branchName.includes(q) || branchCreatedFrom.includes(q)) {
      return true;
    }

    // 4. PROJECT NAME SEARCH
    const projectName = String(task.project_name || task.project || '').toLowerCase();
    if (projectName.includes(q)) {
      return true;
    }

    // 5. ASSIGN DEVELOPER SEARCH
    const assignedUsers = this.getAssignedUsersForTask(task);
    const matchesUser = assignedUsers.some((u) => {
      const first = String(u.firstName || '').toLowerCase();
      const last = String(u.lastName || '').toLowerCase();
      const full = `${first} ${last}`.trim();
      const name = String(u.name || '').toLowerCase();
      const email = String(u.email || '').toLowerCase();
      return (
        first.includes(q) ||
        last.includes(q) ||
        full.includes(q) ||
        name.includes(q) ||
        email.includes(q)
      );
    });
    if (matchesUser) return true;

    const devName = String(task.developer_name || task.assigned_developer || '').toLowerCase();
    if (devName.includes(q)) return true;

    return false;
  };

  getFilteredTasks = () => {
    const { tasks, selectedProject, searchQuery, taskMeta, projects } = this.state;
    const isSuperAdmin = this.isUserSuperAdmin();
    const currentUserId = this.getCurrentUserId();

    const archivedIds = new Set((this.state.archivedTaskIds || []).map(String));

    // Task History shows ONLY Done tasks that are NOT archived
    let list = tasks.filter((t) => {
      const s = String(t.status || '').toLowerCase().trim();
      if (s !== 'done') return false;
      if (archivedIds.has(String(t.id))) return false;
      if (taskMeta[t.id] && taskMeta[t.id].is_archived) return false;
      return true;
    });

    // For non-admin (user side), show only tasks for their assigned projects or tasks assigned to them
    if (!isSuperAdmin) {
      const visibleProjectNames = new Set(
        (projects || []).map((p) => String(p.project_name || '').trim().toLowerCase())
      );
      list = list.filter((task) => {
        const pName = String(task.project_name || '').trim().toLowerCase();
        if (pName && visibleProjectNames.has(pName)) {
          return true;
        }
        const assignedUsers = this.getAssignedUsersForTask(task);
        const taskMemberIds = (this.extractIds(task.member_ids || task.developer_user_ids) || []).map(Number);
        return Boolean(
          currentUserId && (
            Number(task.developer_user_id) === Number(currentUserId) ||
            Number(task.assign_by_id || task.assign_by) === Number(currentUserId) ||
            assignedUsers.some((u) => Number(u.id) === Number(currentUserId)) ||
            taskMemberIds.includes(Number(currentUserId))
          )
        );
      });
    }

    // Project filter
    if (selectedProject !== 'ALL') {
      list = list.filter((t) => (t.project_name || '').trim() === selectedProject.trim());
    }

    // Search filter across Date, Task Name, Branch Name, Project Name, and Assign Developer
    const q = (searchQuery || '').trim();
    if (q) {
      list = list.filter((t) => this.matchesSearchQuery(t, q));
    }

    return list;
  };

  render() {
    const {
      loading,
      projects,
      selectedProject,
      selectedStatus,
      searchQuery,
      taskMeta,
      statusAnchorEl,
      statusActiveTaskId,
      localTestAnchorEl,
      localTestActiveTaskId,
      stagingTestAnchorEl,
      stagingTestActiveTaskId,
      priorityAnchorEl,
      priorityActiveTaskId,
      drawerOpen,
      activeDrawerTask,
      drawerActivity,
      drawerLoadingActivity
    } = this.state;

    const filteredTasks = this.getFilteredTasks();
    const isSuperAdmin = this.isUserSuperAdmin();

    // Table Headers per user specification (Action removed, compact status and test badges, enlarged branch columns)
    const TABLE_HEADERS = [
      { id: 'select', label: '', sortable: false, disablePadding: true, style: { width: '60px', minWidth: '60px', textAlign: 'center' } },
      { id: 'done_date', label: 'Date', sortable: false, style: { width: '110px', minWidth: '105px', textAlign: 'left', whiteSpace: 'nowrap' } },
      { id: 'task', label: 'Task Name', sortable: true, style: { minWidth: '150px', maxWidth: '240px', whiteSpace: 'normal', paddingLeft: '12px' } },
      { id: 'branch_name', label: 'Branch Name', sortable: false, style: { minWidth: '150px' } },
      { id: 'branch_created_from', label: 'Branch-Created From', sortable: false, style: { minWidth: '165px' } },
      { id: 'project_name', label: 'Project Name', sortable: true, style: { minWidth: '120px', textAlign: 'left' } },
      ...(isSuperAdmin ? [{ id: 'assigned_developer', label: 'Assign Developer', sortable: false, style: { minWidth: '130px', textAlign: 'center', whiteSpace: 'nowrap' } }] : []),
      { id: 'status', label: 'Status', sortable: false, style: { minWidth: '85px', textAlign: 'center', whiteSpace: 'nowrap' } },
      { id: 'local_test', label: 'Local Test', sortable: false, style: { minWidth: '135px', textAlign: 'center', whiteSpace: 'nowrap' } },
      { id: 'staging_test', label: 'Staging Test', sortable: false, style: { minWidth: '120px', textAlign: 'center', whiteSpace: 'nowrap', paddingRight: '12px' } }
    ];

    const currentStatusTask = this.state.tasks.find((t) => t.id === statusActiveTaskId);
    const currentPriorityTask = this.state.tasks.find((t) => t.id === priorityActiveTaskId);
    const currentLocalMeta = taskMeta[localTestActiveTaskId] || {};
    const currentStagingMeta = taskMeta[stagingTestActiveTaskId] || {};

    const pageContent = (
      <div style={{ marginBottom: '11%' }}>
        {/* Breadcrumb Card */}
        <div className="holiday-breadcrumb-card">
          <Breadcrumb
            {...this.props}
            primaryPageName="Tasks"
            primaryPageLink="/tasks"
            isSecondaryPage={true}
            secondaryPageName="Task History"
          />
        </div>

        {/* Table Container */}
        <TableComponent
            {...this.props}
            modelName="Task History"
            tableTh={TABLE_HEADERS}
            selected={this.state.selectedTaskIds}
            onSelectionChange={(selected) => this.setState({ selectedTaskIds: selected })}
            bottomBarContent={this.renderBottomBarControls()}
            onRowClick={(row) => this.handleOpenDrawer(row)}
            actionBtns={[]}
            extraHeaderContent={
              <div className="holiday-toolbar-controls">
                {/* View Archive History Button */}
                <Button
                  variant="contained"
                  color="primary"
                  className="common-action-button common-add-button"
                  style={{
                    textTransform: "none",
                    borderRadius: "8px",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    height: "40px",
                    padding: "0 14px",
                    whiteSpace: "nowrap"
                  }}
                  onClick={() => this.props.history.push('/tasks/history/archive')}
                >
                  <HistoryIcon style={{ fontSize: 18, marginRight: 5 }} />
                  Archive History
                </Button>

                {/* Project Filter */}
                <FormControl variant="outlined" className="holiday-year-filter" style={{ width: 130, minWidth: 120 }}>
                  <InputLabel id="history-project-filter-label" style={{ color: '#036dda', fontSize: '0.85rem' }}>
                    Project
                  </InputLabel>
                  <Select
                    labelId="history-project-filter-label"
                    label="Project"
                    value={selectedProject}
                    onChange={(e) => {
                      this.setState({ selectedProject: e.target.value });
                    }}
                    IconComponent={(props) => (
                      <ExpandMoreIcon {...props} style={{ color: '#036dda', cursor: 'pointer' }} />
                    )}
                    style={{ height: '40px' }}
                    MenuProps={{
                      disableScrollLock: true,
                      PaperProps: {
                        className: 'holiday-year-menu',
                        style: {
                          maxHeight: 280
                        }
                      }
                    }}
                  >
                    <MenuItem value="ALL">All Projects</MenuItem>
                    {projects.map((p) => (
                      <MenuItem key={p.id || p.project_name} value={p.project_name}>
                        {p.project_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Search */}
                <div className="holiday-search-wrapper" style={{ minWidth: 230 }}>
                  <TextField
                    className="holiday-search-field hardik"
                    label="Search"
                    value={searchQuery}
                    onChange={(e) => this.setState({ searchQuery: e.target.value })}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        this.setState({ searchQuery: this.state.searchQuery });
                      }
                    }}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: searchQuery !== '',
                      style: {
                        color: '#036dda',
                        transform: searchQuery !== '' ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                        transition: 'transform 0.2s ease-in-out'
                      }
                    }}
                    InputProps={{
                      style: {
                        borderRadius: '25px',
                        height: '40px'
                      },
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          onClick={() => this.setState({ searchQuery: this.state.searchQuery })}
                          style={{ cursor: 'pointer' }}
                        >
                          {searchQuery && (
                            <ClearIcon
                              onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ searchQuery: '' });
                              }}
                              style={{ cursor: 'pointer', marginRight: 4, fontSize: 18 }}
                            />
                          )}
                          <SearchIcon
                            style={{
                              cursor: 'pointer',
                              color: '#036dda',
                              fontSize: 20
                            }}
                            title="Click to search"
                          />
                        </InputAdornment>
                      )
                    }}
                  />
                </div>
              </div>
            }
            tableData={filteredTasks.map((task, index) => {
              const meta = taskMeta[task.id] || {};
              return {
                ...task,
                done_date: (
                  <div style={{ display: 'flex', alignItems: 'left', justifyContent: 'left', width: '100%' }}>
                    <DdMmYyyyDateField
                      value={this.getEffectiveTaskDate(task)}
                      onChange={(e) => {
                        const val = e.target ? e.target.value : e;
                        this.handleInlineMetaChange(task.id, 'done_date', val);
                      }}
                      variant="standard"
                      fullWidth={false}
                      className="tm-history-plain-datepicker"
                      InputProps={{
                        disableUnderline: true,
                        style: {
                          cursor: 'pointer',
                          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                          fontSize: '0.76rem'
                        }
                      }}
                    />
                  </div>
                ),
                task: (
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleOpenDrawer(task);
                    }}
                    title={task.task}
                    className="tm-history-task-title"
                    style={{
                      cursor: 'pointer',
                      fontWeight: 400,
                      fontSize: '0.76rem',
                      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                      maxWidth: '240px',
                      // paddingLeft: '6px',
                      lineHeight: 1.4,
                      display: '-webkit-box',
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      wordBreak: 'break-word',
                      overflowWrap: 'break-word',
                      whiteSpace: 'normal',
                      textDecoration: 'none'
                    }}
                  >
                    <span>{task.task}</span>
                    {Array.isArray(task.sub_tasks_parsed) && task.sub_tasks_parsed.length > 0 && (
                      <span
                        className="tm-subtask-count"
                        style={{
                          marginLeft: '6px',
                          fontWeight: 600,
                          color: '#d32f2f',
                          fontSize: '0.88em',
                          whiteSpace: 'nowrap'
                        }}
                        title={`${task.sub_tasks_parsed.length} sub task${task.sub_tasks_parsed.length > 1 ? 's' : ''}`}
                      >
                        ({task.sub_tasks_parsed.length})
                      </span>
                    )}
                  </div>
                ),
                branch_name: (
                  <input
                    type="text"
                    className="tm-inline-table-input"
                    placeholder="Enter branch name.."
                    value={meta.branch_name !== undefined ? meta.branch_name : (task.branch_name || '')}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => this.handleInlineMetaChange(task.id, 'branch_name', e.target.value)}
                    onBlur={() => this.syncBranchToBackend(task.id)}
                    style={{
                      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                      fontSize: '0.76rem'
                    }}
                  />
                ),
                branch_created_from: (
                  <input
                    type="text"
                    className="tm-inline-table-input"
                    placeholder="Branch Created from..."
                    value={meta.branch_created_from !== undefined ? meta.branch_created_from : (task.branch_created_from || '')}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => this.handleInlineMetaChange(task.id, 'branch_created_from', e.target.value)}
                    onBlur={() => this.syncBranchToBackend(task.id)}
                    style={{
                      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                      fontSize: '0.76rem'
                    }}
                  />
                ),
                project_name: (
                  <div
                    className="tm-history-project-name"
                    style={{
                      textAlign: 'left',
                      // paddingLeft: '10px',
                      fontSize: '0.76rem',
                      fontWeight: 400,
                      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
                    }}
                  >
                    {task.project_name || '-'}
                  </div>
                ),
                assigned_developer: this.renderAssigneeAvatars(task),
                status: (
                  <div
                    style={{ textAlign: 'center', width: '100%' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {this.renderStatusBadge(task.status || 'Done', (e) => {
                      e.stopPropagation();
                      this.setState({ statusAnchorEl: e.currentTarget, statusActiveTaskId: task.id });
                    })}
                  </div>
                ),
                local_test: (
                  <div
                    style={{ textAlign: 'center' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {this.renderTestStatusBadge(
                      (meta.local_test !== undefined ? meta.local_test : task.local_test) || 'Pending',
                      (e) => {
                        e.stopPropagation();
                        this.setState({ localTestAnchorEl: e.currentTarget, localTestActiveTaskId: task.id });
                      }
                    )}
                  </div>
                ),
                staging_test: (
                  <div
                    style={{ textAlign: 'center' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {this.renderTestStatusBadge(
                      (meta.staging_test !== undefined ? meta.staging_test : task.staging_test) || 'Pending',
                      (e) => {
                        e.stopPropagation();
                        this.setState({ stagingTestAnchorEl: e.currentTarget, stagingTestActiveTaskId: task.id });
                      }
                    )}
                  </div>
                )
              };
            })}
            tableCount={filteredTasks.length}
            isLoading={loading}
            shellClassName="holiday-table-shell tm-history-table-shell"
            colNameToShow={[
              'select',
              'done_date',
              'task',
              'branch_name',
              'branch_created_from',
              'project_name',
              ...(isSuperAdmin ? ['assigned_developer'] : []),
              'status',
              'local_test',
              'staging_test'
            ]}
          />
      </div>
    );

    return (
      <div>
        <AuthCheckComponent authToken={this.props.authToken} />
        <Header
          {...this.props}
          authUser={this.props.authUser}
          setAutUser={this.props.setAutUser}
          component={pageContent}
        />
        <Footer {...this.props} />

        {/* Status Dropdown Popover (opens downwards below button) */}
        <Menu
          anchorEl={statusAnchorEl}
          open={Boolean(statusAnchorEl)}
          onClose={() => this.setState({ statusAnchorEl: null, statusActiveTaskId: null })}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          autoFocus={false}
          MenuListProps={{ autoFocusItem: false }}
          PaperProps={{
            className: 'tm-status-menu-paper',
            style: {
              borderRadius: 8,
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.16)',
              minWidth: 160,
              padding: '4px 0',
              marginTop: 4
            }
          }}
        >
          {TASK_STATUS_OPTIONS.map((opt) => {
            const isSelected =
              currentStatusTask &&
              (currentStatusTask.status === opt.id ||
                (opt.id === 'Pending' && currentStatusTask.status === 'To Do'));

            return (
              <MenuItem
                key={opt.id}
                selected={Boolean(isSelected)}
                className={`tm-status-menu-item tm-status-menu-item-${opt.value}${isSelected ? ' is-selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  const taskId = statusActiveTaskId;
                  this.setState({ statusAnchorEl: null, statusActiveTaskId: null }, () => {
                    if (taskId) this.handleStatusChange(taskId, opt.id);
                  });
                }}
              >
                <span style={{ flex: 1 }}>{opt.label}</span>
                {isSelected && <CheckIcon style={{ fontSize: 16, color: '#ffffff', marginLeft: 8 }} />}
              </MenuItem>
            );
          })}
        </Menu>

        {/* Priority Dropdown Popover (opens downwards below button) */}
        <Menu
          anchorEl={priorityAnchorEl}
          open={Boolean(priorityAnchorEl)}
          onClose={() => this.setState({ priorityAnchorEl: null, priorityActiveTaskId: null })}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          autoFocus={false}
          MenuListProps={{ autoFocusItem: false }}
          PaperProps={{
            className: 'tm-priority-menu-paper',
            style: {
              borderRadius: 8,
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.16)',
              minWidth: 140,
              padding: '4px 0',
              marginTop: 4
            }
          }}
        >
          {PRIORITY_OPTIONS.map((opt) => {
            const isSelected = currentPriorityTask && currentPriorityTask.priority === opt.id;
            return (
              <MenuItem
                key={opt.id}
                selected={Boolean(isSelected)}
                className={`tm-priority-menu-item${isSelected ? ' is-selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  const taskId = priorityActiveTaskId;
                  this.setState({ priorityAnchorEl: null, priorityActiveTaskId: null }, () => {
                    if (taskId) this.handlePriorityChange(taskId, opt.id);
                  });
                }}
              >
                <span
                  style={{
                    display: 'inline-block',
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: opt.color,
                    marginRight: 8
                  }}
                />
                <span style={{ flex: 1 }}>{opt.label}</span>
                {isSelected && <CheckIcon style={{ fontSize: 16, color: '#ffffff', marginLeft: 8 }} />}
              </MenuItem>
            );
          })}
        </Menu>

        {/* Local Test Dropdown Popover (opens downwards below button, styled exactly like Status) */}
        <Menu
          anchorEl={localTestAnchorEl}
          open={Boolean(localTestAnchorEl)}
          onClose={() => this.setState({ localTestAnchorEl: null, localTestActiveTaskId: null })}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          autoFocus={false}
          MenuListProps={{ autoFocusItem: false }}
          PaperProps={{
            className: 'tm-status-menu-paper',
            style: {
              borderRadius: 8,
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.16)',
              minWidth: 160,
              padding: '4px 0',
              marginTop: 4
            }
          }}
        >
          {TEST_STATUS_OPTIONS.map((opt) => {
            const isSelected =
              String(currentLocalMeta.local_test || 'Pending').toLowerCase() ===
              String(opt.id).toLowerCase();

            return (
              <MenuItem
                key={opt.id}
                selected={Boolean(isSelected)}
                className={`tm-status-menu-item tm-status-menu-item-${String(opt.id).toLowerCase().replace(/\s+/g, '')}${isSelected ? ' is-selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  const taskId = localTestActiveTaskId;
                  this.setState({ localTestAnchorEl: null, localTestActiveTaskId: null }, () => {
                    if (taskId) this.handleInlineMetaChange(taskId, 'local_test', opt.id);
                  });
                }}
              >
                <span style={{ flex: 1 }}>{opt.label}</span>
                {isSelected && <CheckIcon style={{ fontSize: 16, color: '#ffffff', marginLeft: 8 }} />}
              </MenuItem>
            );
          })}
        </Menu>

        {/* Staging Test Dropdown Popover (opens downwards below button, styled exactly like Status) */}
        <Menu
          anchorEl={stagingTestAnchorEl}
          open={Boolean(stagingTestAnchorEl)}
          onClose={() => this.setState({ stagingTestAnchorEl: null, stagingTestActiveTaskId: null })}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          autoFocus={false}
          MenuListProps={{ autoFocusItem: false }}
          PaperProps={{
            className: 'tm-status-menu-paper',
            style: {
              borderRadius: 8,
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.16)',
              minWidth: 160,
              padding: '4px 0',
              marginTop: 4
            }
          }}
        >
          {TEST_STATUS_OPTIONS.map((opt) => {
            const isSelected =
              String(currentStagingMeta.staging_test || 'Pending').toLowerCase() ===
              String(opt.id).toLowerCase();

            return (
              <MenuItem
                key={opt.id}
                selected={Boolean(isSelected)}
                className={`tm-status-menu-item tm-status-menu-item-${String(opt.id).toLowerCase().replace(/\s+/g, '')}${isSelected ? ' is-selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  const taskId = stagingTestActiveTaskId;
                  this.setState({ stagingTestAnchorEl: null, stagingTestActiveTaskId: null }, () => {
                    if (taskId) this.handleInlineMetaChange(taskId, 'staging_test', opt.id);
                  });
                }}
              >
                <span style={{ flex: 1 }}>{opt.label}</span>
                {isSelected && <CheckIcon style={{ fontSize: 16, color: '#ffffff', marginLeft: 8 }} />}
              </MenuItem>
            );
          })}
        </Menu>

        {/* Slide-out Task Detail Drawer */}
        {drawerOpen && activeDrawerTask && (
          <div className="tm-drawer-backdrop" onClick={this.handleCloseDrawer}>
            <div className="tm-drawer" onClick={(e) => e.stopPropagation()}>
              <div className="tm-drawer-accent-bar tm-drawer-accent-done" />

              {/* Drawer Header */}
              <div className="tm-drawer-header">
                <div className="tm-drawer-key-bar">
                  <div className="tm-drawer-task-id-badge">
                    <span>#{activeDrawerTask.id}</span>
                  </div>
                  <div className="tm-drawer-project-badge">
                    <span>{activeDrawerTask.project_name || 'No Project'}</span>
                  </div>
                </div>

                <div className="tm-drawer-actions">
                  <button
                    type="button"
                    className="tm-drawer-close-btn"
                    onClick={this.handleCloseDrawer}
                    title="Close Drawer"
                  >
                    <CloseIcon style={{ fontSize: 18 }} />
                  </button>
                </div>
              </div>

              {/* Drawer Body */}
              <div className="tm-drawer-body">
                {/* Main Column */}
                <div className="tm-drawer-main-col">
                  {/* Task Title */}
                  <div style={{ marginBottom: 18, marginTop: 8 }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Task Name"
                      disabled
                      value={typeof activeDrawerTask.task === 'string' ? activeDrawerTask.task : (activeDrawerTask.task_name || '')}
                      className="holiday-form-input"
                    />
                  </div>

                  {/* Task Description */}
                  <div style={{ marginBottom: 20 }}>
                    <WysiwygDescriptionEditor
                      label="Task Description"
                      placeholder="No description provided"
                      id="history_task_description"
                      name="description"
                      value={activeDrawerTask.description || ''}
                      disabled
                      rows={6}
                    />
                  </div>

                  {/* Subtasks Section */}
                  {(activeDrawerTask.sub_tasks_parsed || []).length > 0 && (
                    <div className="tm-drawer-section" style={{ marginBottom: 20 }}>
                      <div className="tm-section-label">
                        <span>Subtasks</span>
                        <span className="tm-subtask-progress-label">
                          {(activeDrawerTask.sub_tasks_parsed || []).filter((st) => st.status === 'Done').length}
                          &nbsp;/&nbsp;
                          {(activeDrawerTask.sub_tasks_parsed || []).length} done
                        </span>
                      </div>

                      <div className="tm-subtasks-list">
                        {(activeDrawerTask.sub_tasks_parsed || []).map((subTask, idx) => (
                          <div
                            key={idx}
                            className={`tm-subtask-item ${subTask.status === 'Done' ? 'is-done' : ''}`}
                            style={{ cursor: 'default' }}
                          >
                            <div className="tm-subtask-check">
                              {subTask.status === 'Done' ? (
                                <CheckCircleOutlineIcon style={{ color: '#10b981', fontSize: 18 }} />
                              ) : (
                                <RadioButtonUncheckedIcon style={{ color: '#94a3b8', fontSize: 18 }} />
                              )}
                            </div>
                            <span
                              className={`tm-subtask-text ${subTask.status === 'Done' ? 'is-done' : ''}`}
                              style={{ flex: 1 }}
                            >
                              {subTask.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Full Activity & History in Drawer */}
                  <div className="tm-drawer-section" style={{ marginTop: 16 }}>
                    <div
                      className="tm-activity-collapse-header"
                      onClick={() => {
                        const nextOpen = !this.state.drawerActivityOpen;
                        this.setState({ drawerActivityOpen: nextOpen });
                        if (nextOpen && activeDrawerTask && activeDrawerTask.id) {
                          this.fetchDrawerActivity(activeDrawerTask.id);
                        }
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                        padding: '10px 14px',
                        backgroundColor: 'var(--tm-surface-subtle, #f8fafc)',
                        borderRadius: 8,
                        border: '1px solid var(--tm-border, #e2e8f0)',
                        userSelect: 'none',
                        transition: 'all 0.2s ease',
                        marginBottom: this.state.drawerActivityOpen ? 12 : 0
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontWeight: 600, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                          Complete Activity & History
                        </span>
                      </div>
                      <ExpandMoreIcon
                        style={{
                          fontSize: 20,
                          color: '#64748b',
                          transition: 'transform 0.25s ease',
                          transform: this.state.drawerActivityOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                        }}
                      />
                    </div>

                    {this.state.drawerActivityOpen && (
                      <div>
                        {drawerActivity.length === 0 ? (
                          <div className="tm-activity-empty">
                            <span>No activity recorded yet for this task.</span>
                          </div>
                        ) : (() => {
                          const sortedActivity = this.sortActivityLogsLatestFirst(drawerActivity);
                          const page = this.state.drawerActivityPage || 0;
                          const rowsPerPage = this.state.drawerActivityRowsPerPage || 5;
                          const paginatedActivity = rowsPerPage > 0
                            ? sortedActivity.slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                            : sortedActivity;

                          return (
                            <>
                              <div className="tm-activity-timeline">
                                {paginatedActivity.map((log, idx) => {
                                  const msg = log.description || log.message || '';
                                  const time = log.timestamp || log.created_at || '';
                                  let accentClass = 'tm-activity-entry';
                                  if (/creat|add/i.test(msg)) accentClass += ' is-create';
                                  else if (/status/i.test(msg)) accentClass += ' is-status';
                                  else if (/priority/i.test(msg)) accentClass += ' is-priority';
                                  else if (/delet/i.test(msg)) accentClass += ' is-delete';
                                  else if (/assign/i.test(msg)) accentClass += ' is-assign';

                                  return (
                                    <div key={idx} className={accentClass}>
                                      <div className="tm-activity-dot" />
                                      <div className="tm-activity-content">
                                        <div className="tm-activity-message">{msg}</div>
                                        {time && (
                                          <div className="tm-activity-time">{this.formatDateTime(time)}</div>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                              <CommonTablePagination
                                className="tm-drawer-activity-pagination"
                                count={sortedActivity.length}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                onChangePage={(e, newPage) => this.setState({ drawerActivityPage: newPage })}
                                onChangeRowsPerPage={(e) => {
                                  const val = parseInt(e.target.value, 10);
                                  this.setState({ drawerActivityRowsPerPage: val, drawerActivityPage: 0 });
                                }}
                              />
                            </>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Details Sidebar */}
                <div className="tm-drawer-side-col">
                  {/* Status */}
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Status</span>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontWeight: 400 }}>
                      <CheckCircleIcon style={{ fontSize: 18, color: '#10b981' }} />
                      <span>{activeDrawerTask.status || 'To Do'}</span>
                    </div>
                  </div>

                  <div className="tm-side-divider" />

                  {/* Assignees */}
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Assignee</span>
                    <div className="tm-assignee-profiles-row">
                      {this.renderAssigneeAvatars(activeDrawerTask)}
                    </div>
                  </div>

                  <div className="tm-side-divider" />

                  {/* Project */}
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Project</span>
                    <div className="tm-side-project-badge">
                      <AssignmentIcon className="tm-side-project-icon" style={{ fontSize: 15 }} />
                      <span>{activeDrawerTask.project_name || '—'}</span>
                    </div>
                  </div>

                  <div className="tm-side-divider" />

                  {/* Priority */}
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Priority</span>
                    <span style={{ fontWeight: 400 }}>{activeDrawerTask.priority || 'Medium'}</span>
                  </div>



                  <div className="tm-side-divider" />

                  {/* Branch Name */}
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Branch Name</span>
                    <span style={{ fontWeight: 400, wordBreak: 'break-all', fontSize: 13, color: '#334155' }}>
                      {(this.state.taskMeta[activeDrawerTask.id] && this.state.taskMeta[activeDrawerTask.id].branch_name) || activeDrawerTask.branch_name || '—'}
                    </span>
                  </div>

                  <div className="tm-side-divider" />

                  {/* Branch Created From */}
                  <div className="tm-side-detail-block">
                    <span className="tm-side-block-label">Branch-Created From</span>
                    <span style={{ fontWeight: 400, wordBreak: 'break-all', fontSize: 13, color: '#334155' }}>
                      {(this.state.taskMeta[activeDrawerTask.id] && this.state.taskMeta[activeDrawerTask.id].branch_created_from) || activeDrawerTask.branch_created_from || '—'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(TaskHistory);
